module.exports = __webpack_public_path__ + "img/gf.1376831d.svg";